"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticComponentDebug = void 0;
const react_1 = __importStar(require("react"));
const config_1 = __importDefault(require("next/config"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const common_1 = require("../common");
const modal_1 = require("../modal");
const styles_1 = require("./styles");
const MONERA_DEBUG_QUERY_PARAM = 'moneraDebug';
const StaticComponentDebug = (props) => {
    const { id, state = {}, childrenIds = [], children, debug: { depth, forceDebug = false, name, componentMissing } } = props;
    const [showMoneraDebug, setShowMoneraDebug] = (0, react_1.useState)(false);
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (forceDebug || location.href.includes(`${MONERA_DEBUG_QUERY_PARAM}=true`)) {
            setShowMoneraDebug(true);
        }
    }, []);
    const renderMoneraDebug = () => {
        const config = (0, config_1.default)();
        let isEnvStageProd = true;
        if (config) {
            const { publicRuntimeConfig } = config;
            isEnvStageProd = publicRuntimeConfig.envStage === 'prod';
        }
        if (!isEnvStageProd && (0, monera_app_core_1.isClientSide)()) {
            return showMoneraDebug;
        }
        return false;
    };
    if (!renderMoneraDebug()) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(styles_1.StaticComponentDebugContainer, Object.assign({ className: "static-component-debug" }, props.debug),
        !common_1.debuggerIgnoredComponentsSet.has(id) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.DebugButton, Object.assign({}, props.debug, { onClick: () => setOpenModal(true) }),
                react_1.default.createElement("strong", null, componentMissing ? 'Debug' : 'Inspect'),
                react_1.default.createElement("br", null),
                `"${id}"`),
            react_1.default.createElement(modal_1.Modal, { scrollable: true, hasCloseButton: true, isOpen: openModal, close: () => setOpenModal(false) },
                react_1.default.createElement(styles_1.StaticComponentDebugBanner, Object.assign({}, props.debug),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "id: ")),
                        react_1.default.createElement("span", null, JSON.stringify(id))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "name: ")),
                        react_1.default.createElement("span", null, JSON.stringify(name))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "depth: ")),
                        react_1.default.createElement("span", null, JSON.stringify(depth))),
                    Object.keys(state).length > 0 && (react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "state: "),
                        react_1.default.createElement("pre", { style: { display: 'block', overflow: 'scroll' } }, JSON.stringify(state, null, 2)))),
                    childrenIds.length > 0 && (react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "children: ")),
                        react_1.default.createElement("span", null, childrenIds.map((childId) => JSON.stringify(childId)).join(', ')))))))) : null,
        children));
};
exports.StaticComponentDebug = StaticComponentDebug;
__exportStar(require("./types"), exports);
